import { render, staticRenderFns } from "./CmgEntreeCard.vue?vue&type=template&id=45407d85&scoped=true&lang=pug"
import script from "./cmg-entree-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-entree-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgEntreeCard.vue?vue&type=style&index=0&id=45407d85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45407d85",
  null
  
)

export default component.exports